<template>
  <div class="content_main">
    <div class="content_main_top">
      <a-button type="primary" @click="addcar">添加车辆</a-button>
    </div>
    <div class="content_main_top">
      <a-input
        class="a_select_self margin_self"
        v-model="serchInfo.plateNumber"
        allowClear
        placeholder="车牌号"
        @keyup.enter.native="serch_get_lis"
      />
      <a-input
        class="a_select_self margin_self"
        v-model="serchInfo.carUser"
        allowClear
        placeholder="用车人"
        @keyup.enter.native="serch_get_lis"
      />
      <a-select
        show-search
        allowClear
        placeholder="所属公司"
        class="margin_self"
        @change="handlecompany"
        v-model="serchInfo.companyId"
        @keyup.enter.native="serch_get_lis"
        style="width: 120px"
      >
        <a-select-option :value="item.deptId" v-for="(item, index) in companylist" :key="index">
          {{ item.title }}
        </a-select-option>
      </a-select>
      <a-tree-select
        allowClear
        :treeData="deptTree2"
        v-model="serchInfo.deptId"
        :disabled="!serchInfo.companyId"
        placeholder="所属部门"
        @keyup.enter.native="serch_get_lis"
        class="margin_self"
        style="width: 170px"
        treeDefaultExpandAll
      >
      </a-tree-select>
      <a-date-picker
        :disabled-date="disabledDate"
        v-model="serchInfo.statusDate"
        @change="changestatusDate"
        allowClear
        @keyup.enter.native="serch_get_lis"
        class="margin_self"
        placeholder="日期"
      />
      <!-- <a-select show-search allowClear v-model="serchInfo.deptId" :disabled="!serchInfo.companyId" placeholder="所属部门"
			 @keyup.enter.native="serch_get_lis" class="margin_self" style="width: 170px">
				<a-select-option :value="item.dept_id" v-for="(item, index) in deptlist" :key="index">
					{{ item.dept_name }}
				</a-select-option>
			</a-select> -->
      <a-button type="primary" @click="serch_get_lis"> 查询 </a-button>
      <a-button type="primary" ghost @click="result"> 重置 </a-button>
    </div>
    <div class="content_main_center_scroll" id="content_main_center_scroll">
      <a-table
        :data-source="lis"
        bordered
        :loading="loading"
        :pagination="pagination"
        @change="handleTableChange"
        :scroll="{ x: 1000, y: scroll_y, scrollToFirstRowOnChange: true }"
      >
        <a-table-column key="index" title="序号" data-index="index" width="70px">
          <template scope="text, record, index">{{
            (pagination.current - 1) * pagination.pageSize + index + 1
          }}</template>
        </a-table-column>
        <a-table-column key="plateNumber" title="车牌号" ellipsis="true" data-index="plateNumber" />
        <a-table-column
          key="latestMileage"
          title="最新里程数"
          ellipsis="true"
          width="120px"
          data-index="latestMileage"
        />
        <a-table-column
          key="nextMaintainanceNum"
          title="下次保养里程"
          ellipsis="true"
          width="120px"
          data-index="nextMaintainanceNum"
        />
        <a-table-column key="frameNumber" title="车驾号" ellipsis="true" data-index="frameNumber" />
        <a-table-column key="companyName" title="所属公司" ellipsis="true" data-index="companyName" />
        <a-table-column key="deptName" title="所属部门" ellipsis="true" data-index="deptName" />
        <a-table-column key="statusNow" title="当前车辆状态" width="120px" ellipsis="true" data-index="statusNow">
          <template scope="text,record">
            <div :style="{ color: text == '在用' ? 'red' : text == '预约' ? '#ffc53d' : 'green' }">
              {{ text }}
            </div>
          </template>
        </a-table-column>
        <!-- <a-table-column key="carUser" title="用车人" ellipsis="true" data-index="carUser" /> -->
        <a-table-column key="carBrand" title="品牌型号" ellipsis="true" data-index="carBrand" />
        <a-table-column key="carInsurancePeriod" title="车险有效期" ellipsis="true" data-index="carInsurancePeriod" />
        <a-table-column key="peopleNumber" title="核载人数" ellipsis="true" data-index="peopleNumber" />
        <a-table-column key="types" title="车辆属性" ellipsis="true" data-index="types">
          <template scope="text,record">
            {{ carMap[text] }}
          </template>
        </a-table-column>
        <!-- <a-table-column key="carStatus" title="车辆状态" ellipsis="true" data-index="carStatus">
					<template scope="text,record">
						<div :style="{color:carColors[text]}">
							{{carStatusMap[text]}}
						</div>
					</template>
				</a-table-column> -->

        <!-- <a-table-column key="statusUpdateUser" title="状态变更人" ellipsis="true" data-index="statusUpdateUser"/>
				<a-table-column key="statusUpdateTime" title="变更时间" ellipsis="true" data-index="statusUpdateTime"/>
				<a-table-column key="statusUpdateReason" title="变更原因" ellipsis="true" data-index="statusUpdateReason"/> -->
        <a-table-column title="状态">
          <template scope="text,record">
            <a-switch :checked="record.status == 1" @change="statusChange(record)" />
          </template>
        </a-table-column>
        <a-table-column title="操作" width="200px">
          <template scope="text,record">
            <a @click="show_details(record)">编辑</a>
            <a-divider type="vertical" />
            <a @click="show_edit(record)">详情</a>
            <a-divider type="vertical" />
            <a @click="show_return(record)">还车</a>
          </template>
        </a-table-column>
      </a-table>
    </div>
    <a-modal
      title="车辆查询-新增"
      :visible="carvisible"
      @cancel="carvisible = false"
      :confirm-loading="confirmLoading"
      width="70%"
      :maskClosable="false"
    >
      <template slot="footer">
        <a-button key="submit" type="primary" :loading="loading" @click="handleOkCar"> 添加 </a-button>
        <a-button key="back" @click="carvisible = false"> 取消 </a-button>
      </template>
      <a-form-model :model="form" :rules="rules" ref="ruleForm" :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-row>
          <a-col :span="8">
            <a-form-model-item label="车牌号" prop="plateNumber">
              <a-input v-model="form.plateNumber" allowClear placeholder="请输入"></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item label="车架号" prop="frameNumber">
              <a-input v-model="form.frameNumber" allowClear placeholder="请输入"></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item label="隶属公司" prop="companyId">
              <a-select allowClear placeholder="隶属公司" v-model="form.companyId" @change="handlecompanyplan">
                <a-select-option :value="item.deptId" v-for="(item, index) in companylist" :key="index">
                  {{ item.title }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="8">
            <a-form-model-item label="隶属部门">
              <a-tree-select
                allowClear
                :treeData="deptTree"
                placeholder="请输入"
                :disabled="!form.companyId"
                v-model="form.deptId"
                @change="deptchange"
                treeDefaultExpandAll
              >
              </a-tree-select>
              <!-- <a-select allowClear placeholder="隶属部门" :disabled="!form.companyId" v-model="form.subjectionDeptId">
							<a-select-option :value="item.dept_id" v-for="(item, index) in deptlist" :key="index">
								{{ item.dept_name }}
							</a-select-option>
						</a-select> -->
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item label="品牌型号">
              <a-input v-model="form.carBrand" allowClear placeholder="请输入"></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item label="核载人数">
              <a-input v-model="form.peopleNumber" type="number" allowClear placeholder="请输入"></a-input>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="8">
            <a-form-model-item label="车辆属性" prop="types">
              <a-select v-model="form.types" placeholder="请选择">
                <a-select-option :key="index" v-for="(item, index) in carMap" :value="index">
                  {{ item }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item label="车险有效期" prop="carInsurancePeriod">
              <a-date-picker
                v-model="form.carInsurancePeriod"
                @change="changCar"
                allowClear
                style="width: 287px"
                placeholder="请选择"
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item label="上次保养里程(km)" prop="lastMaintainanceNum">
              <a-input
                v-model="form.lastMaintainanceNum"
                type="number"
                @blur="changenext"
                allowClear
                placeholder="请输入"
              ></a-input>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="8">
            <a-form-model-item label="下次保养里程(km)" prop="nextMaintainanceNum">
              <a-input v-model="form.nextMaintainanceNum" type="number" allowClear placeholder="请输入"></a-input>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </a-modal>
    <a-modal
      v-model="changecar"
      title="车辆查询-编辑"
      @cancel="changecar = false"
      :confirm-loading="confirmLoading"
      width="70%"
      :maskClosable="false"
    >
      <template slot="footer">
        <a-button key="submit" type="primary" @click="changeOk"> 确定 </a-button>
        <a-button key="back" @click="changecar = false"> 取消 </a-button>
      </template>
      <a-form-model :model="formrow" :rules="rules" ref="ruleForm2" :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-row>
          <a-col :span="8">
            <a-form-model-item
              label="车牌号"
              prop="plateNumber"
              :rules="{
                required: true,
                message: '请输入车牌号码',
                trigger: 'change',
              }"
            >
              <a-input v-model="formrow.plateNumber" allowClear placeholder="请输入"></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item
              label="车架号"
              prop="frameNumber"
              :rules="{
                required: true,
                message: '请输入车架号码',
                trigger: 'change',
              }"
            >
              <a-input v-model="formrow.frameNumber" allowClear placeholder="请输入"></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item
              label="所属公司"
              prop="companyId"
              :rules="{
                required: true,
                message: '请选择所属公司',
                trigger: 'change',
              }"
            >
              <a-select allowClear placeholder="所属公司" v-model="formrow.companyId" @change="handlecompanyplan2">
                <a-select-option :value="item.deptId" v-for="(item, index) in companylist" :key="index">
                  {{ item.title }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="8">
            <a-form-model-item label="所属部门">
              <a-tree-select
                allowClear
                :treeData="deptTree"
                placeholder="请选择"
                :disabled="!formrow.companyId"
                v-model="formrow.deptId"
                treeDefaultExpandAll
              >
              </a-tree-select>
              <!-- <a-select allowClear placeholder="隶属部门" :disabled="!form.companyId" v-model="form.subjectionDeptId">
								<a-select-option :value="item.dept_id" v-for="(item, index) in deptlist" :key="index">
									{{ item.dept_name }}
								</a-select-option>
							</a-select> -->
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item label="品牌型号">
              <a-input v-model="formrow.carBrand" allowClear placeholder="请输入"></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item label="核载人数">
              <a-input v-model="formrow.peopleNumber" allowClear placeholder="请输入"></a-input>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="8">
            <a-form-model-item
              label="车辆属性"
              prop="types"
              :rules="{
                required: true,
                message: '请选择车辆属性',
                trigger: 'change',
              }"
            >
              <a-select v-model="formrow.types" allowClear placeholder="请选择">
                <a-select-option :key="index" v-for="(item, index) in carMap" :value="index">
                  {{ item }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item label="车险有效期">
              <a-date-picker
                v-model="formrow.carInsurancePeriod"
                @change="changCar2"
                allowClear
                style="width: 287px"
                placeholder="请选择"
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item label="上次保养里程(km)">
              <a-input
                v-model="formrow.lastMaintainanceNum"
                type="number"
                @blur="changenexttwo"
                allowClear
                placeholder="请输入"
              ></a-input>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="8">
            <a-form-model-item label="最新里程数">
              <a-input v-model="formrow.latestMileage" allowClear placeholder="请输入"></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item label="下次保养里程(km)">
              <a-input v-model="formrow.nextMaintainanceNum" type="number" allowClear placeholder="请输入"></a-input>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </a-modal>
    <a-modal
      v-model="editcar"
      title="车辆查询-详情"
      @cancel="editcar = false"
      :confirm-loading="confirmLoading"
      width="60%"
      :maskClosable="false"
    >
      <template slot="footer">
        <a-button key="submit" type="primary" @click="editcar = false"> 确定 </a-button>
        <a-button key="back" @click="editcar = false"> 取消 </a-button>
      </template>
      <a-form-model :model="formrow" :rules="rules" ref="ruleForm2" :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-row>
          <a-col :span="8">
            <a-form-model-item label="车牌号">
              <div>
                {{ formrow.plateNumber }}
              </div>
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item label="最新里程数">
              <div>
                {{ formrow.latestMileage }}
              </div>
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item label="车架号">
              <div>
                {{ formrow.frameNumber }}
              </div>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="8">
            <a-form-model-item label="所属公司">
              <div>
                {{ formrow.companyName }}
              </div>
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item label="所属部门">
              <div>
                {{ formrow.deptName }}
              </div>
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item label="品牌型号">
              <div>
                {{ formrow.carBrand }}
              </div>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="8">
            <a-form-model-item label="核载人数">
              <div>
                {{ formrow.peopleNumber }}
              </div>
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item label="车辆属性">
              <div>
                {{ carMap[formrow.types] }}
              </div>
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item label="车险有效期">
              <div>
                {{ formrow.carInsurancePeriod }}
              </div>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="8">
            <a-form-model-item label="上次保养里程">
              <div>
                {{ formrow.lastMaintainanceNum }}
              </div>
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item label="下次保养里程">
              <div>
                {{ formrow.nextMaintainanceNum }}
              </div>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
      <a-table :data-source="editlis" bordered :pagination="false">
        <a-table-column key="index" title="序号" data-index="index" width="70px">
          <template scope="text, record, index">{{ index + 1 }}</template>
        </a-table-column>
        <a-table-column key="startDate" title="预计出行日期" ellipsis="true" data-index="startDate" />
        <a-table-column key="endDate" title="预计还车日期" ellipsis="true" data-index="endDate" />
        <a-table-column key="plateNumber" title="车牌号" ellipsis="true" data-index="plateNumber" />
        <a-table-column key="carUser" title="用车人" ellipsis="true" data-index="carUser" />
        <a-table-column key="carStatus" title="车辆状态" ellipsis="true" data-index="carStatus">
          <template scope="text,record">
            <div :style="{ color: carColors[text] }">
              {{ carStatusMap[text] }}
            </div>
          </template>
        </a-table-column>
      </a-table>
    </a-modal>
    <a-modal
      v-model="returncar"
      title="还车列表"
      @cancel="returncar = false"
      :confirm-loading="confirmLoading"
      width="60%"
      :maskClosable="false"
    >
      <template slot="footer">
        <a-button key="submit" type="primary" @click="returncar = false"> 确定 </a-button>
        <a-button key="back" @click="returncar = false"> 取消 </a-button>
      </template>
      <a-table :data-source="returnlis" bordered :pagination="false">
        <a-table-column key="index" title="序号" data-index="index" width="70px">
          <template scope="text, record, index">{{ index + 1 }}</template>
        </a-table-column>
        <a-table-column key="startDate" title="预计出行日期" ellipsis="true" data-index="startDate" />
        <a-table-column key="endDate" title="预计还车日期" ellipsis="true" data-index="endDate" />
        <a-table-column key="plateNumber" title="车牌号" ellipsis="true" data-index="plateNumber" />
        <a-table-column key="carUser" title="用车人" ellipsis="true" data-index="carUser" />
        <a-table-column key="carStatus" title="车辆状态" ellipsis="true" data-index="carStatus">
          <template scope="text,record">
            <div :style="{ color: carColors[text] }">
              {{ carStatusMap[text] }}
            </div>
          </template>
        </a-table-column>
        <a-table-column title="操作">
          <template scope="text,record">
            <a @click="return_car(record)">还车</a>
          </template>
        </a-table-column>
      </a-table>
    </a-modal>
    <a-modal v-model="commentvisit" title="确认还车吗?">
      <template slot="footer">
        <a-button key="back" @click="commentvisit = false"> 取消 </a-button>
        <a-button key="submit" type="primary" @click="handleOkReason"> 确认 </a-button>
      </template>
      <a-textarea placeholder="请输入还车原因" v-model="comment" />
    </a-modal>
  </div>
</template>
<script>
import { limitCompany } from '@/utils/limitCompany'
import { tree_all, enableParent } from '@/api/purchase'
import { getDeptListEnable2 } from '@/api/system'
import {
  listAllPage,
  biz_car_registration,
  biz_car_registration_update,
  biz_car_list_detail,
  biz_car_list_return_car,
  biz_car_return_car,
} from '@/api/administrative'
// import // get_dept_tree,
// // get_dept_tree2,
// '@/api/assetmenag'
export default {
  data() {
    return {
      companylist: [],
      companyData: [],
      deptData: [],
      changecar: false,
      labelCol: {
        span: 9,
      },
      wrapperCol: {
        span: 15,
      },
      labelCol4: {
        span: 6,
      },
      wrapperCol4: {
        span: 18,
      },
      deptTree: [],
      deptTree2: [],
      editcar: false,
      returncar: false,
      commentvisit: false,
      comment: '',
      editrow: {},
      form: {},
      rules: {
        plateNumber: [
          {
            required: true,
            message: '请输入车牌号',
            trigger: 'change',
          },
        ],
        frameNumber: [
          {
            required: true,
            message: '请输入车架号',
            trigger: 'blur',
          },
        ],
        companyId: [
          {
            required: true,
            message: '请选择所属公司',
            trigger: 'change',
          },
        ],
        types: [
          {
            required: true,
            message: '请选择车辆属性',
            trigger: 'change',
          },
        ],
        carInsurancePeriod: [
          {
            required: true,
            message: '请选择车险有效期',
            trigger: 'change',
          },
        ],
        lastMaintainanceNum: [
          {
            required: true,
            message: '请输入上次保养里程',
            trigger: 'change',
          },
        ],
        nextMaintainanceNum: [
          {
            required: true,
            message: '请输入下次保养里程',
            trigger: 'change',
          },
        ],
      },
      serchInfo: {
        plateNumber: '',
        carUser: '',
        companyId: undefined,
        deptId: undefined,
      },
      labelCol: {
        span: 8,
      },
      wrapperCol: {
        span: 16,
      },
      scroll_y: 150,
      loading: false,
      lis: [],
      editlis: [],
      returnlis: [],
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        pageSizeOptions: ['10', '20', '30', '40', '50'],
        showLessItems: true,
        showSizeChanger: true,
      },
      pagination2: {
        current: 1,
        pageSize: 10,
        total: 0,
        pageSizeOptions: ['10', '20', '30', '40', '50'],
        showLessItems: true,
        showSizeChanger: true,
      },
      is_details: false,
      formrow: {},
      carvisible: false,
      rowlis: {},
    }
  },
  created() {
    limitCompany().then((res) => {
      console.log(res,"created")
      res.forEach((item) => {
        if (item.deptId) {
          this.companylist.push(item)
        }
      })
    })
  },
  mounted() {
    this.get_list()
    // enableParent().then((res) => {
    //   console.log('1111111111111111111111111111111111111111')
    //   var data = []
    //   var data1 = {}
    //   res.rows.forEach((item) => {
    //     if (item.isCompany == 0) {
    //       if (data.length != 0) {
    //         data.forEach((item1) => {
    //           if (item1.deptId != item.deptId) {
    //             data1 = {
    //               deptId: item.deptId,
    //               title: item.deptName,
    //               parentId: item.parentId,
    //             }
    //           }
    //         })
    //         data.push(data1)
    //       } else {
    //         data1 = {
    //           deptId: item.deptId,
    //           title: item.deptName,
    //           parentId: item.parentId,
    //         }
    //         data.push(data1)
    //       }
    //     }
    //   })
    //   this.deptData = data
    // })
    // get_dept_tree
    // tree_all().then((res) => {
    //   var arry = []
    //   this.companyData = res.data[0]
    //   this.companyData.unshift({
    //     deptId: 0,
    //     title: '所有公司',
    //     children: [],
    //   })
    //   for (var i = 0; i < this.companyData.length; i++) {
    //     for (var j = 0; j < this.deptData.length; j++) {
    //       if (this.companyData[i].deptId == this.deptData[j].parentId) {
    //         arry.push(this.companyData[i])
    //       } else if (this.companyData[i].children.length > 0) {
    //         this.companyData[i].children.forEach((item) => {
    //           if (item.deptId == this.deptData[j].parentId) {
    //             arry.push(this.companyData[i])
    //           }
    //         })
    //       }
    //     }
    //   }
    //   // this.companylist =
    //   var array1 = []
    //   array1[0] = arry[0]
    //   for (var i = arry.length - 1; i >= 0; i--) {
    //     console.log(array1, 'array1==============================')
    //     if (array1.indexOf(arry[i].deptId) != -1) {
    //       array1.push(arry[i])
    //     }
    //   }
    //   this.companylist = array1
    //   console.log(this.companylist, 'this.companylist===========================')
    // })

    this.$nextTick(() => {
      var max_h = $('#content_main_center_scroll').height()
      setTimeout(() => {
        this.scroll_y = max_h - $('.ant-table-header').height() - 120
      }, 1000)
    })
    // get_dept_tree2().then((res) => {
    // 	this.companylist2 = res.data.dept_lis
    // })
  },
  methods: {
    disabledDate(current) {
      return current < moment().subtract(1, 'day')
    },
    changestatusDate(value, dateString) {
      this.serchInfo.statusDate = dateString
    },
    changCar(value, dateString) {
      this.form.carInsurancePeriod = dateString
    },
    changCar2(value, dateString) {
      this.formrow.carInsurancePeriod = dateString
    },
    changenext() {
      this.form.lastMaintainanceNum = Number(this.form.lastMaintainanceNum)
      this.form.nextMaintainanceNum = Number(this.form.lastMaintainanceNum) + 5000
      this.$forceUpdate()
    },
    changenexttwo() {
      this.formrow.lastMaintainanceNum = Number(this.formrow.lastMaintainanceNum)
      this.formrow.nextMaintainanceNum = Number(this.formrow.lastMaintainanceNum) + 5000
      this.$forceUpdate()
    },
    statusChange(row) {
      var that = this
      var statusC = row.status == '1' ? '禁用' : '启用'
      this.$confirm({
        title: '是否确认 ' + statusC + ' 车辆?',
        onOk() {
          row.status = row.status == '1' ? '2' : '1'
          biz_car_registration_update({
            status: row.status,
            id: row.id,
          }).then((res) => {
            if (res.code == 200) {
              that.$message.success('修改状态成功')
            } else {
              that.$message.error(res.msg)
              return
            }
          })
        },
        onCancel() {
          that.$message.success('你取消了操作')
        },
      })
    },
    handleOkReason() {
      biz_car_return_car({
        id: this.rowlis.id,
        remark: this.comment,
      }).then((res) => {
        this.commentvisit = false
        this.show_return(this.rowlis)
      })
    },
    return_car(row) {
      this.rowlis = row
      this.commentvisit = true
    },
    changecarStatus() {
      if (this.formrow.carStatus == 3) {
        this.formrow.carUser = ''
      }
    },
    result() {
      this.serchInfo = {}
    },
    changeOk() {
      this.$refs.ruleForm2.validate((valid) => {
        if (valid) {
          biz_car_registration_update(this.formrow).then((res) => {
            if (res.code == 200) {
              this.changecar = false
              this.$message.success('编辑成功')
              this.get_list()
            } else {
              this.$message.error(res.msg)
              return
            }
          })
        }
      })
    },
    handleOkCar() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.form.carStatus = 3
          biz_car_registration(this.form).then((res) => {
            if (res.code == 200) {
              this.carvisible = false
              this.$message.success('添加成功')
              this.get_list()
            } else {
              this.$message.error(res.msg)
              return
            }
          })
        }
      })
    },
    deptchange() {
      this.$forceUpdate()
    },
    //切换公司
    handlecompanyplan(value) {
      this.deptTree = []
      this.form.deptId = undefined
      for (let i = 0; i < this.companylist.length; i++) {
			if(this.form.companyId == this.companylist[i].deptId){
				this.deptTree = this.companylist[i].children
			}
		}
    },
    handlecompanyplan2(value) {
      this.deptTree = []
      this.formrow.deptId = undefined
       for (let i = 0; i < this.companylist.length; i++) {
			if(this.formrow.companyId == this.companylist[i].deptId){
				this.deptTree = this.companylist[i].children
			}
		}
    },
    buildtree2(list, arr, parentId) {
      list.forEach((item) => {
        if (item.parentId === parentId) {
          var child = {
            key: item.deptId,
            value: item.deptId, // value是给modal的select用的，2者属性不一样
            title: item.deptName,
            scopedSlots: {
              title: 'title',
            },
            children: [],
          }
          this.buildtree2(list, child.children, item.deptId)
          if (child.children.length === 0) {
            delete child.children
          }
          arr.push(child)
        }
      })
    },
    addcar() {
      this.carvisible = true
      this.form = {}
    },
    //切换公司
	  handlecompany(e) {
      this.serchInfo.deptId = undefined
		for (let i = 0; i < this.companylist.length; i++) {
			if(this.serchInfo.companyId == this.companylist[i].deptId){
				this.deptTree2 = this.companylist[i].children
			}
		}
    },
    // handlecompany(value) {
    //   this.deptTree2 = []
    //   this.deptlist = []
    //   this.serchInfo.deptId = undefined
    //   this.$nextTick(() => {
    //     this.deptData.forEach((item) => {
    //       console.log(item, 'item ===========================')
    //       if (item.parentId == e) {
    //         this.deptTree2.push(item)
    //       } else {
    //         this.companylist.forEach((item1) => {
    //           console.log(item1, 'item1 ===========================')
    //           if ((item1.value = e)) {
    //             item1.children.forEach((item2) => {
    //               console.log(item2, 'item2 ===========================')
    //               if (item2.value == item.parentId) {
    //                 this.deptTree2.push(item2)
    //               }
    //             })
    //           }
    //         })
    //       }
    //     })

    //     let newArr = []

    //     console.log(this.deptTree2, 'this.newArr================================')
    //     for (let k = this.deptTree2.length - 1; k >= 0; k--) {
    //       if (newArr.length == 0) {
    //         newArr.push(this.deptTree2[k])
    //       } else {
    //         newArr.forEach((item) => {
    //           console.log(item, '-------------------------')
    //           if (item.deptId == this.deptTree2[k].deptId || item.parentId != this.deptTree2[k].parentId) {
    //             this.deptTree2.splice(k, 1)
    //           } else {
    //             newArr.push(this.deptTree2[k])
    //           }
    //         })
    //       }
    //     }
    //     console.log(newArr, 'newArr=======================')
    //     console.log(this.deptTree2, 'this.deptTree2================================')
    //   })
    // },
    //获取列表
    get_list() {
      listAllPage({
        pageNum: this.pagination.current,
        pageSize: this.pagination.pageSize,
        plateNumber: this.serchInfo.plateNumber,
        carUser: this.serchInfo.carUser,
        companyId: this.serchInfo.companyId,
        deptId: this.serchInfo.deptId,
        statusDate: this.serchInfo.statusDate,
      }).then((res) => {
        console.log(res)
        if (res.code == 200) {
          var lis = res.rows
          this.lis = res.rows
          const pagination = { ...this.pagination }
          pagination.total = res.total
          this.pagination = pagination
        } else {
          this.$message.error(res.msg)
        }
        this.loading = false
      })
    },
    //重置
    reset() {
      this.serchInfo = {
        purchaseCode: '',
        createBy: '',
        status: undefined,
        buStatus: undefined,
        company_id: undefined,
        deptId: undefined,
        createTimelist: [],
      }
    },
    //搜索
    serch_get_lis() {
      this.loading = true
      this.pagination.current = 1
      this.get_list()
    },
    //改变分页
    handleTableChange(pagination, filters, sorter) {
      this.pagination.current = pagination.current
      this.pagination.pageSize = pagination.pageSize
      this.loading = true
      this.get_list()
    },
    // 编辑
    show_details(row) {
      row.types = row.types + ''
      var rows = row
      let resData = {}
      for (let key in rows) {
        resData[key] = rows[key]
      }
      this.formrow = resData
           this.formrow.companyId = Number(this.formrow.companyId)
           if(this.formrow.deptId!=null) {
              this.formrow.deptId = Number(this.formrow.deptId)

           }
      
      this.formrow.statusUpdateUser = this.$store.getters.userInfo.userName
         for (let i = 0; i < this.companylist.length; i++) {
			if(this.formrow.companyId == this.companylist[i].deptId){
				this.deptTree = this.companylist[i].children
			}
		}
      this.changecar = true
      
      // getDeptListEnable2().then((res) => {
      //      const data = res.rows
      //   if (data.length > 0) {
      //     const min = Math.min(...data.map((m) => m.parentId))
      //     this.buildtree2(data, this.deptTree, row.companyId)
      //   }
      // })
    },
    //详情
    show_edit(row) {
      var rows = row
      let resData = {}
      for (let key in rows) {
        resData[key] = rows[key]
      }
      this.formrow = resData
      biz_car_list_detail({
        plateNumber: row.plateNumber,
      }).then((res) => {
        this.editlis = res.rows
        this.editcar = true
      })
    },
    show_return(row) {
      biz_car_list_return_car({
        plateNumber: row.plateNumber,
      }).then((res) => {
        this.returnlis = res.rows
        this.returncar = true
      })
    },
  },
}
</script>
<style scoped lang='less'>
.ant-table td {
  white-space: nowrap;
}
</style>
